const actions = {
  SET_STATE: 'settings/SET_STATE',
  CHANGE_SETTING: 'settings/CHANGE_SETTING',
  SET_THEME: 'settings/SET_THEME',
  SET_SETTINGS: 'settings/SET_SETTINGS',
  SET_IS_GRID: 'settings/SET_IS_GRID',
  SET_IS_LEAKED: 'settings/SET_IS_LEAKED',
} as const

export type SettingsActionTypes = typeof actions

export default actions
